<template>
    <div class="coach-assignments">
        <div class="block-header">
            <div class="md-title">{{ completedActivitiesLabel }}</div>
            <div class="pager" v-if="assignments.length && assignments.length > sizeAssignment">
                <button
                  class="pager-nav button-previous"
                  @click="prevPageAssignments"
                  :disabled="pageNumberAssignments === 0"
                >Previous</button>
                <button
                  class="pager-nav button-next"
                  @click="nextPageAssignments"
                  :disabled="pageNumberAssignments >= pageCountAssignments-1"
                >Next</button>
            </div>
        </div>

      <div v-if="assignments.length">
        <md-card class="overflow md-elevation-2 md-layout-item">
          <table :value="paginatedDataAssignments" md-sort="name" md-sort-order="asc" md-card>
            <tr>
              <th>
                <span @click="toggleSort('title')" :class="{ active: sorted['title'] }">
                Title
                <md-icon>{{
                    sorted['title'] === "ASC" ? "expand_less" : "expand_more"
                  }}</md-icon>
                </span>
              </th>
              <th>
                <span @click="toggleSort('completed')" :class="{ active: sorted['completed'] }">
                  Date Completed
                <md-icon>{{
                    sorted['completed'] === "ASC" ? "expand_less" : "expand_more"
                  }}</md-icon>
                </span>
              </th>
              <th>
                <span @click="toggleSort('coach')" :class="{ active: sorted['coach'] }">
                Assigned by
                <md-icon>{{
                    sorted['coach'] === "ASC" ? "expand_less" : "expand_more"
                  }}</md-icon>
                </span>
              </th>
            </tr>
            <tr :key="index" v-for="(item, index) in paginatedDataAssignments">
              <td>
                <a target="_blank" :href="getSubmissionUrl(item)">{{ item.title }}</a>
              </td>
              <td>{{ item.completed }}</td>
              <td>{{ item.coach }}</td>
            </tr>
          </table>
        </md-card>
      </div>
      <div v-else class="assignments-cards">
        <div class="empty-text">Nothing completed yet.</div>
      </div>

    </div>
</template>

<script>
  import Vue from "vue";

  export default {
    name: "LearnerAssignmentList",
    data() {
      let cols = {title: 0,completed:0, coach:0};
      let sorted = {};
      let keys = Object.keys(cols);
      for (let i = 0; i < keys.length; i++) {
        sorted[keys[i]] = 0;
      }
      return {
        pageNumberAssignments: 0,
        sizeAssignment: 6,
        assignments: window.drupalSettings.controller.assignments || [],
        coachAssignmentsLabel:
          window.drupalSettings.group_catch_config.labels.coach_assignments || "",
        completedActivitiesLabel:
          window.drupalSettings.group_catch_config.labels.completed_activities_label || "",
        sorted: sorted,
        assignment_settings: window.drupalSettings.controller.assignment_settings,

      };
    },
    mounted() {
      this.sorted['completed'] = 'ASC';
      this.toggleSort('completed');
    },
    computed: {
      pageCountAssignments() {
        let l = this.assignments.length,
          s = this.sizeAssignment;
        return Math.ceil(l / s);
      },
      paginatedDataAssignments() {
        const start = this.pageNumberAssignments * this.sizeAssignment,
          end = start + this.sizeAssignment;
        return this.assignments.slice(start, end);
      },
    },
    methods: {
      log(msg) {
        console.log(msg);
      },
      toggleSort(column) {
        let direction;
        let keys = Object.keys(this.sorted);

        for (let i = 0; i < keys.length; i++) {
          if (keys[i] == column) {
            direction = "DESC";
            if (this.sorted[column]) {
              direction = this.sorted[column] === "DESC" ? "ASC" : "DESC";
            }
            Vue.set(this.sorted, keys[i], direction)
          } else {
            Vue.set(this.sorted, keys[i], 0)
          }
        }

        this.assignments.sort((a, b) => {
          let itemA = a[column];
          let itemB = b[column];

          if (column == 'completed') {
            let itemA = +a['completed_timestamp'];
            let itemB = +b['completed_timestamp'];
            if (direction === 'DESC') {
              return itemB - itemA;
            } else {
              return itemA - itemB;
            }
          }

          if (direction === 'DESC') {
            if (itemA < itemB) {
              return 1;
            }
            else if (itemA > itemB) {
              return -1;
            }
            else {return 0; }
          } else {
              if (itemA > itemB) {
                return 1;
              }
              else if (itemA < itemB) {
                return -1;
              }
              else {return 0;}
          }
        });
      },

      getSubmissionUrl(item) {
        if (item.type === 'assignment_submission') {
          return '/assignment-submission/' + item.id;
        }
        else {
          return '/node/' + item.id;
        }
      },
      nextPageAssignments() {
        this.pageNumberAssignments++;
      },
      prevPageAssignments() {
        this.pageNumberAssignments--;
      },
    },
  };
</script>
<style lang="scss">
.assignments-data {
  th span:hover {
    cursor: pointer;
  }
}
</style>
